import { Component, ViewChild } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { EmployeeCareerProgramService } from '../employee-career-program/employee-career-program.service';
import { CareerPathService } from '../employee-career-path/employee-career-path.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export interface User {
  employeeName: string,
  userId: string
}

@Component({
  selector: 'app-program-catalogue',
  templateUrl: './program-catalogue.component.html',
  styleUrls: ['./program-catalogue.component.css']
})
export class ProgramCatalogueComponent {

  allPrograms: any;
  showAllViewMore = true;
  allProgramsSearch: string = '';
  allProgramsPageNumber: number = 1;

  pageSize: number = 8;

  elasticSearchPrograms = [];
  elasticSearchProgarmIds = [0];
  isloading: boolean=false;
  isCareerPathPrograms: string = '';

  @ViewChild('elasticSearch', { read: MatAutocompleteTrigger })
  autoComplete: MatAutocompleteTrigger;

  private searchSubject: Subject<string> = new Subject<string>();


  constructor(private spinner: NgxSpinnerService, private toastr: ToastrService, private service: EmployeeCareerProgramService, private route: Router, private careerPathservice: CareerPathService) {
    this.isCareerPathPrograms = window.history.state.selectedGrade || '';
  }

  ngOnInit(): void {
    this.isCareerPathPrograms ? this.careerPathservice.careerPathProgramIds.subscribe(data => this.elasticSearchProgarmIds = data) : '';
    this.getAllPrograms();
    this.initDebounce();
  }

  initDebounce() {
    this.searchSubject.pipe(
      debounceTime(1000)
    ).subscribe(searchText => {
      this.searchAllPrograms(searchText);
    });
  }
  onSearchTextChanged(searchText: string) {
    this.allProgramsSearch = searchText;
    this.searchSubject.next(searchText);
  }
  clearSearchProgramText(event) {
    event.value = "";
    this.allProgramsSearch = "";
    this.allProgramsPageNumber = 1;
    this.allPrograms = [];
    this.getAllPrograms();
  }
  clearSearch(event) {
    if (event == "") {
      this.allProgramsSearch = "";
      this.allProgramsPageNumber = 1;
      this.allPrograms = [];
      this.getAllPrograms();
    }
  }
  searchAllPrograms(data: any) {
    this.allPrograms = [];
    this.allProgramsPageNumber = 1;
    var model = {
      searchKey: data,
      pageSize: this.pageSize,
      pageNumber: this.allProgramsPageNumber,
      programIds: this.elasticSearchProgarmIds
    }
    this.isloading=true;
    this.spinner.show();
    this.service.getAllPrograms(model).subscribe((res: any) => {
      if (res) {
        if (res.length < 8) {
          this.showAllViewMore = false;
        }
        if (res.length === 8) {
          this.showAllViewMore = true;
        }
        if (res.length >= 0) {
          this.allProgramsPageNumber += 1;
          this.allPrograms = Array.from(res);
        }

      }
      this.spinner.hide();
      this.isloading=false;

    }, error => {
      this.spinner.hide();
      this.isloading=false;
      this.toastr.error("Data Fetching Failed")

    });
  }

  loadAllPrograms() {
    var model = {
      searchKey: this.allProgramsSearch,
      pageSize: this.pageSize,
      pageNumber: this.allProgramsPageNumber,
      programIds: this.elasticSearchProgarmIds
    }
    this.isloading=true;
    this.spinner.show();
    this.service.getAllPrograms(model).subscribe((res: any) => {
      if (res) {
        if (res.length < 8) {
          this.showAllViewMore = false;
        }
        if (res.length === 8) {
          this.showAllViewMore = true;
        }
        if (res.length >= 0) {
          this.allProgramsPageNumber += 1;
          var x = Array.from(res);
          this.allPrograms = Array.from(this.allPrograms);
          x.forEach(program => {
            this.allPrograms.push(program);
          })
        }
        this.spinner.hide();
        this.isloading=false;

      }
    }, error => {
      this.spinner.hide();
      this.isloading=false;
      this.toastr.error("Data Fetching Failed")
    })
  }

  getAllPrograms() {
    var model = {
      searchKey: this.allProgramsSearch,
      pageSize: this.pageSize,
      pageNumber: this.allProgramsPageNumber,
      programIds: this.elasticSearchProgarmIds
    }
    this.isloading=true;
    this.spinner.show();
    this.service.getAllPrograms(model).subscribe(res => {
      if (res) {
        this.allProgramsPageNumber += 1;
        this.allPrograms = res;
      }

      this.spinner.hide();
      this.isloading=false;
    }, error => {
      this.spinner.hide();
      this.isloading=false;
      this.toastr.error("Data Fetching Failed")

    })
  }

  goToProgramDetails(program) {
    const selectedGrade = window.history.state.selectedGrade;
    this.isCareerPathPrograms ?
      this.route.navigateByUrl('Home/employee-career/employee-Career-path/program-catalogue/' + program.programID, { state: { prevUrl: 'Home/employee-career/employee-Career-path/program-catalogue', selectedGrade:selectedGrade } }) : this.route.navigateByUrl('Home/employee-career/program-catalogue/' + program.programID);
  }

  goToProgramDetail(program) {
    this.route.navigateByUrl('Home/employee-career/employee-Career-program/' + program.programId, { state: { prevUrl: 'pc' } });
  }

  employeeCareerPathNavigate() {
    this.route.navigateByUrl('Home/employee-career/employee-Career-path');
  }
}
